import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=55182b3c&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=55182b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55182b3c",
  null
  
)

export default component.exports